import React, { useEffect } from "react";
import Card from "components/card";
import { Form} from 'antd';
import { connect } from "react-redux";
import { 
	getFarmerInfoDetails, doFarmerInfoCreate, doFarmerInfoUpdate 
} from "../../../../redux/farmerinfo/farmerInfoState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import FarmerProfileFields from "./FarmerProfileFields";

const FarmerInfoForm = ({recordId, getRecord, mode, doCreate, doUpdate, recordData, requesting, success, farmerId, ...props}) => {
	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { ...restData } = recordData;
	        const initialValues = {
	            ...restData,	            
	        };
			
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			formData.is_household_head = formData.is_household_head === false ? 0 : formData.is_household_head;
			formData.is_pwd = formData.is_pwd === false ? 0 : formData.is_pwd;
			formData.is_4ps_beneficiary = formData.is_4ps_beneficiary === false ? 0 : formData.is_4ps_beneficiary;
			formData.is_indigenous_group = formData.is_indigenous_group === false ? 0 : formData.is_indigenous_group;
			formData.with_government_id = formData.with_government_id === false ? 0 : formData.with_government_id;
			formData.has_assoc_coop = formData.has_assoc_coop === false ? 0 : formData.has_assoc_coop;
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FarmerProfileFields recordData={recordData} mode={mode}/>

	 			<CrudButtons baseRoute="/console/farmer-informations" mode={mode} recordId={farmerId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.farmerInfo.details?.data,
  	requesting: state.farmerInfo.details?.requesting,
  	success: state.farmerInfo.details?.success,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmerInfoDetails(id)),
  	doCreate: (data) => dispatch(doFarmerInfoCreate(data)),
  	doUpdate: (data) => dispatch(doFarmerInfoUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmerInfoForm);
